// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"3011a55b","977":"07e889ee"}[chunkId] + ".chunk.js";
};